{
  "items": [
    {
      "fileName": "GENERIC-PeopleDiverseCity-01.mp4",
      "description": "The video shows one man, an adult male with a tan or olive skin tone, short dark black hair, and a full, thick dark beard and mustache covering his jaw and chin. The man is laughing broadly with his mouth wide open, showing white teeth, and visible smile lines and creases near his eyes, giving a joyful, energetic, happy visible expression. The man is wearing a top, a light blue, pale blue button up collared shirt with thin white pinstripes, a striped pattern. The setting is an outdoor residential street environment, blurred softly out of focus behind the man, showing parked cars, light colored buildings or houses, green trees and foliage, and a paved road or sidewalk. The lighting is bright and warm, consistent with strong backlight sunlight shining from behind the man, creating a warm glow around his head and shoulders and causing his ears to appear illuminated. The color palette is warm and bright, dominated by light blue, tan, beige, and white tones, with green accents from the trees. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a shallow depth of field, keeping the street and buildings background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "parked cars",
        "buildings",
        "houses",
        "trees",
        "foliage",
        "street",
        "sidewalk",
        "shirt pattern",
        "backlight",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "energetic",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "backlight",
        "bright lighting",
        "natural light",
        "warm tone",
        "casual",
        "lifestyle",
        "man",
        "male",
        "beard",
        "mustache",
        "striped shirt",
        "pinstripe",
        "blue",
        "light blue",
        "cars",
        "buildings",
        "trees",
        "foliage",
        "street",
        "residential"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCity-02.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone and short, straight, blonde hair styled in a bob haircut just above her shoulders. The woman has dark brown eyebrows, dark eyes, and pink, mauve colored lipstick, with a soft, gentle smile showing a hint of white teeth, giving a calm, warm, pleasant visible expression. The woman is wearing a top, a white button up collared shirt or blouse. The setting is an outdoor urban environment, blurred softly out of focus behind the woman, showing a red brick building facade, a dark green door or sign, and a paved sidewalk or plaza area. The lighting is soft, bright, and natural, consistent with daytime daylight, evenly illuminating the woman's face without harsh shadows. The color palette is warm and neutral, dominated by red brick, white, blonde, and dark green tones. The composition is an extreme close up, closeup, tight face framing, with the woman's face and shoulders filling most of the frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a lifestyle or corporate portrait style stock video with a shallow depth of field, keeping the brick building background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "brick building",
        "door",
        "sign",
        "sidewalk",
        "plaza",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "calm",
        "warm",
        "gentle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "neutral tone",
        "urban",
        "lifestyle",
        "corporate",
        "woman",
        "blonde hair",
        "bob haircut",
        "short hair",
        "straight hair",
        "white",
        "blouse",
        "shirt",
        "brick",
        "red brick",
        "building",
        "green door"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCity-03.mp4",
      "description": "The video shows one woman, an adult female with a dark brown skin tone and dark black hair pulled back tightly away from her face with a center part. The woman has dark brown eyes and purple, mauve colored lipstick, with a broad, open mouthed smile showing white teeth, giving a joyful, warm, confident visible expression. The woman is wearing a top, a gray, dark gray heather knit sweater with a mock neck or high collar. The setting is a busy outdoor city street environment, blurred softly out of focus behind the woman, showing multiple cars and vehicles, tall city buildings, a large round domed structure, possibly a water tower, string lights or banners, colorful signage, and pedestrians and street lights in the distance. The lighting is soft, bright, and natural, consistent with overcast or diffused daytime lighting, evenly illuminating the woman's face without harsh shadows. The color palette is neutral and muted, dominated by gray, tan, and beige tones, with colorful accents from the distant signage and vehicles. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or urban portrait style stock video with a shallow depth of field, keeping the busy city street background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "cars",
        "vehicles",
        "buildings",
        "domed structure",
        "water tower",
        "string lights",
        "signage",
        "pedestrians",
        "street lights",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "confident",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "overcast",
        "neutral tone",
        "muted tone",
        "urban",
        "city",
        "lifestyle",
        "woman",
        "sweater",
        "mock neck",
        "gray",
        "knit",
        "cars",
        "buildings",
        "dome",
        "water tower",
        "signage",
        "colorful"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCity-04.mp4",
      "description": "The video shows one man, a young adult male with a tan or light skin tone, short dark wavy hair, and light stubble or a short goatee along his jawline. In one visible moment the man has a neutral, serious, still visible expression with his lips closed, looking directly at the camera, and in another visible moment he smiles broadly with his mouth open, showing white teeth, giving a joyful, warm, friendly visible expression. The man is wearing a jacket, a dark teal, gray blazer or sport coat, layered over a white, light blue collared shirt with no tie, left open at the collar. The setting is an outdoor city street environment, blurred softly out of focus behind the man, showing a red car and a white car parked or driving along the road, light colored buildings, green trees, and a pink, red painted bicycle lane on the sidewalk. The lighting is bright and natural, consistent with clear daytime sunlight, evenly illuminating the man's face and creating defined highlights. The color palette is cool and neutral, dominated by teal, gray, white, and green tones, with red accents from the car and bicycle lane. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or lifestyle style stock video with a shallow depth of field, keeping the street and vehicles background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "cars",
        "vehicles",
        "buildings",
        "trees",
        "bicycle lane",
        "street",
        "blazer color",
        "lighting"
      ],
      "attributes": [
        "serious",
        "neutral",
        "joyful",
        "warm",
        "friendly",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "cool tone",
        "corporate",
        "lifestyle",
        "man",
        "male",
        "goatee",
        "stubble",
        "blazer",
        "jacket",
        "teal",
        "gray",
        "white",
        "shirt",
        "cars",
        "red car",
        "buildings",
        "trees",
        "bicycle lane",
        "street"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseCity-05.mp4",
      "description": "The video shows one woman, an adult female with a tan or olive skin tone and long, dark brown wavy hair falling past her shoulders, moving dynamically in the wind. The woman has dark brown eyes, small pearl stud earrings, and pink lipstick, with a broad, open mouthed smile showing white teeth, giving a joyful, warm, cheerful visible expression, and appears to be looking slightly off to the side. The woman is wearing a coat, a tan, camel colored coat, along with a scarf, a navy blue, dark blue scarf wrapped around her neck. The setting is an outdoor urban storefront environment, blurred softly out of focus behind the woman, showing a building facade, a dark colored sign or doorway, a red decorative element or awning on the right side of the frame, and bright circular bokeh light spots scattered throughout the background. The lighting is bright and warm, consistent with strong sunlight, creating a glowing backlight effect through the woman's hair. The color palette is warm and rich, dominated by tan, camel, navy blue, and brown tones, with a red accent on the right side of the frame. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing slightly off camera. The visual style is photographic, realistic, and resembles a lifestyle or fashion style stock video with a shallow depth of field and warm, glowing bokeh, keeping the storefront background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "building facade",
        "sign",
        "doorway",
        "awning",
        "bokeh lights",
        "coat color",
        "scarf color",
        "backlight",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "cheerful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "bokeh",
        "backlight",
        "golden light",
        "bright lighting",
        "natural light",
        "warm tone",
        "urban",
        "fashion",
        "lifestyle",
        "woman",
        "wavy hair",
        "brown hair",
        "earrings",
        "coat",
        "tan",
        "camel",
        "scarf",
        "navy blue",
        "blue",
        "building",
        "storefront",
        "red accent"
      ]
    }
  ]
}
